// Mirrors graphql-server/src/impl/AuthenticationErrors.ts.
export const AuthErrorCode = {
  RATE_LIMITED: "AUTH_RATE_LIMITED",
  VERIFICATION_EXPIRED: "AUTH_VERIFICATION_EXPIRED",
  INVALID_CODE: "AUTH_INVALID_CODE",
  NO_ACTIVE_VERIFICATION: "AUTH_NO_ACTIVE_VERIFICATION",
  INVALID_PHONE: "AUTH_INVALID_PHONE",
} as const;

export type AuthErrorCode = (typeof AuthErrorCode)[keyof typeof AuthErrorCode];

type GraphQLErrorLike = { extensions?: { code?: unknown } };
type ApolloErrorLike = {
  graphQLErrors?: GraphQLErrorLike[];
  cause?: { errors?: GraphQLErrorLike[] } & GraphQLErrorLike;
} & GraphQLErrorLike;

export function getAuthErrorCode(err: unknown): AuthErrorCode | undefined {
  if (!err || typeof err !== "object") return undefined;
  const e = err as ApolloErrorLike;
  const candidates: GraphQLErrorLike[] = [];
  if (Array.isArray(e.graphQLErrors)) candidates.push(...e.graphQLErrors);
  const cause = e.cause;
  if (cause) {
    if (Array.isArray(cause.errors)) candidates.push(...cause.errors);
    candidates.push(cause);
  }
  candidates.push(e);
  for (const c of candidates) {
    const code = c.extensions?.code;
    if (typeof code === "string" && (Object.values(AuthErrorCode) as string[]).includes(code)) {
      return code as AuthErrorCode;
    }
  }
  return undefined;
}

// Keep the cap below Twilio's 5 to leave headroom for accidental races.
export const CLIENT_MAX_CODE_ATTEMPTS = 4;
